var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('video',{ref:"myVideo",staticClass:"video-box",attrs:{"src":_vm.videopath,"poster":_vm.poster,"oncontextmenu":"return false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }